module.exports = __webpack_public_path__ + "frontend-assets/img/big_card_ab.085271c1.png";